import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import PublicRoute from '@/PublicRoute';
import { PublicLayout } from 'sama_global/components/PublicLayout';

import Profile from 'sama_global/pages/profile/Edit';

import Signin from 'sama_global/pages/signin/Signin';

import PrimaryLayout from 'sama_global/components/Layout';
import OlimpicStats from 'sama_global/pages/olimpic/Stats';
import OlimpicRating from 'sama_global/pages/olimpic/Rating';
import Run from 'sama_global/pages/olimpic/Run';
import OlimpicDiplomas from 'sama_global/pages/olimpic/Diplomas';
import OlimpicDiploma from 'sama_global/pages/olimpic/Diploma';
import { ROLE } from '@/modules/User';
import { IndexLayout } from '@/components/PrimaryLayout';
import Purchase from 'sama_global/pages/purchase/Purchase';
import StyledPreRun from 'sama_global/pages/olimpic/StyledPreRun';
import Fallback from './components/Fallback';

import About from './pages/olimpic/About';
import OlimpicRanking from './pages/olimpic/Ranking';
import OlimpicParticipants from './pages/olimpic/participants/Participants';
import OlimpicParticipantEdit from './pages/olimpic/participants/Edit';
import OlimpicParticipantCreate from './pages/olimpic/participants/Create';
import Participate from './pages/olimpic/participants/Participate';
import Delegates from './pages/delegates/Delegates';
import DelegatesEdit from './pages/delegates/Edit';
import DelegatesCreate from './pages/delegates/Create';
import ProtectRoute from './components/ProtectRoute';
import Logout from './pages/signin/Logout';
import { isAdmin, moreThan } from './utils/protect';

const Routes = () => (
  <Router>
    <Switch>
      <PublicRoute exact path="/" layout={IndexLayout} component={Signin} />

      <PublicRoute path="/signin" layout={IndexLayout} component={Signin} />

      <PublicRoute path="/logout" layout={PublicLayout} component={Logout} />

      <PublicRoute
        path="/purchase"
        layout={PublicLayout}
        component={Purchase}
      />

      <ProtectRoute
        path="/profile"
        layout={PrimaryLayout}
        component={Profile}
      />

      <ProtectRoute
        exact
        path="/delegates"
        layout={PrimaryLayout}
        component={Delegates}
        protect={isAdmin}
      />

      <ProtectRoute
        path="/delegates/edit"
        layout={PrimaryLayout}
        component={DelegatesEdit}
        protect={isAdmin}
      />

      <ProtectRoute
        path="/delegates/create"
        layout={PrimaryLayout}
        component={DelegatesCreate}
        protect={isAdmin}
      />

      <ProtectRoute
        path="/olimpic/participate"
        layout={PrimaryLayout}
        component={Participate}
        protect={state => !state.olimpic.sama?.participant}
        to="/olimpic/about"
      />

      <ProtectRoute
        exact
        path="/olimpic/participants"
        layout={PrimaryLayout}
        component={OlimpicParticipants}
      />

      <ProtectRoute
        path="/olimpic/participants/edit/"
        layout={PrimaryLayout}
        component={OlimpicParticipantEdit}
        protect={moreThan(ROLE.SCHOOL)}
      />

      <ProtectRoute
        path="/olimpic/participants/create"
        layout={PrimaryLayout}
        component={OlimpicParticipantCreate}
        protect={moreThan(ROLE.SCHOOL)}
      />

      <ProtectRoute
        path="/olimpic/ranking"
        layout={PrimaryLayout}
        component={OlimpicRanking}
        protect={state => isAdmin(state) || state.olimpic.sama?.show_results}
        to="/olimpic/about"
      />

      <ProtectRoute
        path="/olimpic/stats"
        layout={PrimaryLayout}
        component={OlimpicStats}
      />

      <ProtectRoute
        path="/olimpic/rating"
        layout={PrimaryLayout}
        component={OlimpicRating}
        protect={state => isAdmin(state) || state.olimpic.sama?.show_rating}
        to="/olimpic/about"
      />

      <ProtectRoute
        path="/olimpic/about"
        exact
        layout={PrimaryLayout}
        component={About}
      />

      <ProtectRoute
        path="/olimpic/run/:mode"
        layout={PrimaryLayout}
        component={Run}
        protect={state =>
          isAdmin(state) ||
          (state.olimpic.sama && !state.olimpic.sama?.participant?.result)
        }
        to="/olimpic/about"
      />

      <ProtectRoute
        path="/olimpic/:type/pre-run/"
        layout={PrimaryLayout}
        component={StyledPreRun}
        protect={state =>
          isAdmin(state) ||
          (state.olimpic.sama && !state.olimpic.sama?.participant?.result)
        }
        to="/olimpic/about"
      />

      <ProtectRoute
        path="/olimpic/diploma/:mode/:id?/:lang?"
        layout={PrimaryLayout}
        component={OlimpicDiploma}
        protect={state => isAdmin(state) || state.olimpic.sama?.show_diploms}
      />
      <ProtectRoute
        path="/olimpic/diplomas"
        layout={PrimaryLayout}
        component={OlimpicDiplomas}
        protect={state => isAdmin(state) || state.olimpic.sama?.show_diploms}
      />

      <PublicRoute path="*" layout={PrimaryLayout} component={Fallback} />
    </Switch>
  </Router>
);

export default Routes;
